export default (data, allowNullOrUndefined) => {
    var formBody = [];
  
    allowNullOrUndefined = (allowNullOrUndefined == null || allowNullOrUndefined == undefined) ? true : allowNullOrUndefined;
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      if(allowNullOrUndefined || encodedValue != null && encodedValue != undefined) {
        formBody.push(encodedKey + "=" + encodedValue);
      }
    }
  
    formBody = formBody.join("&");
  
    return formBody;
  }
  